import React from 'react';
import { Loader2Icon, RefreshCwIcon, TriangleAlertIcon } from 'lucide-react';
import { useStore } from '../../contexts/StoreContext';

/** Aviso discreto sobre el estado de conexión con la planilla del 0 KM. */
export function CatalogSyncNotice() {
  const {
    catalogSync
  } = useStore();
  if (catalogSync.status === 'loading') {
    return <p className="mt-4 inline-flex items-center gap-2 text-sm text-mist" role="status" data-id="element-423" data-mp="19waoy4rc7cw5">
        <Loader2Icon className="h-4 w-4 animate-spin text-neon-hi" aria-hidden data-id="element-424" data-mp="14z0xykoaut67" />
        Actualizando inventario…
      </p>;
  }
  if (!catalogSync.error) return null;
  return <div className="mt-4 flex flex-col gap-3 rounded-xl border border-warn/30 bg-warn/10 p-3 text-sm sm:flex-row sm:items-center sm:justify-between" role="status" data-id="element-425" data-mp="vxkp4hd4uz43">
      <p className="flex items-start gap-2" data-id="element-426" data-mp="2qaj0z5ehe3tj">
        <TriangleAlertIcon className="mt-0.5 h-4 w-4 shrink-0 text-warn" aria-hidden data-id="element-427" data-mp="2qaam57yssofp" />
        {catalogSync.sheetCount > 0 ? 'No pudimos actualizar el inventario. Mostramos la última versión disponible.' : 'No pudimos conectar con el inventario en este momento.'}
      </p>
      <button type="button" onClick={catalogSync.refresh} className="btn btn-ghost h-9 shrink-0" data-id="element-428" data-mp="2hnp9leeyzimf">
        <RefreshCwIcon className="h-4 w-4" aria-hidden data-id="element-429" data-mp="23nxo6sm4izye" /> Reintentar
      </button>
    </div>;
}